import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import GlobalSearch from '../../Base/GlobalSearch';
import Pagination from '../../Base/Pagination';
import Header from '../../Base/Header';
import UsersList from './UsersList';
import types from '../../../redux/types';

const SEARCH_SELECT = [
  { value: 'id', label: 'ID' },
  { value: 'email', label: 'Email' },
  { value: 'phone', label: 'Mobile Phone' },
  { value: 'country', label: 'Country' },
  { value: 'ip', label: 'IP' },
  { value: 'kyc', label: 'KYC' },
  { value: 'approved_documents', label: 'Approved Documents' },
  { value: 'is_active', label: 'Status' },
];

const Users = () => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const [field, setField] = useState('');
  const { loading, data } = useSelector(state => state.users);

  const perPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const lastPage = data?.last_page || 1;

  useEffect(() => {
    const body = { params: { per_page: perPage, current_page: currentPage } };
    if (search && field) {
      body.params = { ...body.params, value: search, field };
    }

    dispatch({
      type: types.GET_USERS_START,
      payload: {
        ...body.params,
      },
    });
  }, [dispatch, perPage, currentPage, search, field]);

  const handleSubmit = ({ value, select }) => {
    setCurrentPage(1);
    setSearch(value);
    setField(select);
  };

  return (
    <>
      <Header title="User Management">
        <GlobalSearch
          placeholder="Search"
          onSubmit={handleSubmit}
          field={SEARCH_SELECT[0].value}
          data={SEARCH_SELECT}
        />
      </Header>
      <div className="dash-container">
        <div className="dash-container__content">
          <div className="dash-table-wrap">
            <UsersList users={data?.data} loading={loading} />
          </div>
          {lastPage > 1 && (
            <Pagination
              pageCount={lastPage}
              forcePage={currentPage - 1}
              onPageChange={setCurrentPage}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Users;
